import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import ActionButton from '@themes/account/components/ActionButton';
import Stack from '@mui/material/Stack';
import { AccountHeader } from '@themes/account/components';
import { GetAccountSettings } from '@themes/common/data';
import { IsB2B } from '@commons/helpers';
const { customers_account_edit_details, customers_account_edit_description, customers_account_edit_button } = GetAccountSettings().translations;
export const AccountEditWrapper = styled((props) => _jsx(Paper, Object.assign({}, props, { elevation: 0 })))(({ theme }) => ({
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 0,
}));
const AccountEditCard = () => {
    const handleEdit = useCallback(() => {
        if (IsB2B) {
            globalThis.open('/pages/redigera-konto', '_self');
        }
        else {
            globalThis.open('/account/addresses', '_self');
        }
    }, []);
    return (_jsx(Stack, Object.assign({ spacing: 1 }, { children: _jsxs(AccountEditWrapper, { children: [_jsx(AccountHeader, { children: customers_account_edit_details }), _jsx(Typography, { children: customers_account_edit_description }), _jsx(ActionButton, Object.assign({ sx: { marginTop: 2, width: 'fit-content' }, onClick: handleEdit }, { children: customers_account_edit_button }))] }) })));
};
export default AccountEditCard;
